import * as angular from "angular";
import { playServiceEslApi } from "./eslapi/app";
import { playServiceDrupal } from "./drupal/app";

export let playServiceApi = angular.module("play.service.api", [playServiceDrupal.name, playServiceEslApi.name]);

export * from "./eslapi/app";
export * from "./drupal/app";
